(() => {
  class RotatingStatsBanner {
    constructor(element) {
      if (element._instance) {
        element._instance.destroy();
      }

      this.element = element;
      this.viewport = element.querySelector('.rotating-stats-banner__viewport');
      this.track = element.querySelector('.rotating-stats-banner__track');
      this.items = Array.from(element.querySelectorAll('.rotating-stats-banner__item'));

      if (!this.viewport || !this.track || !this.items.length) return;

      this.desktopType = element.dataset.animation || 'slide';
      this.mobileType = element.dataset.mobileAnimation || 'slide';
      this.mobileBreakpoint = window.matchMedia('(max-width: 749px)');

      this.delay = parseInt(this.element.dataset.delay, 10) || 4000;
      this.transitionDuration = parseInt(this.element.dataset.transition, 10) || 850;

      this.holdTimer = null;
      this.cleanupTimer = null;
      this.resizeTimer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.currentIndex = 0;
      this.type = this.getCurrentType();

      this.init();

      this.handleResize = this.handleResize.bind(this);
      window.addEventListener('resize', this.handleResize);

      this.element._instance = this;
    }

    getCurrentType() {
      return this.mobileBreakpoint.matches ? this.mobileType : this.desktopType;
    }

    init() {
      this.type = this.getCurrentType();

      this.element.classList.remove('animation--slide', 'animation--ticker');
      this.element.classList.add(`animation--${this.type}`);

      this.resetItems();

      if (this.type === 'ticker') {
        this.initTicker();
      } else {
        this.initSlider();
      }
    }

    resetItems() {
      this.clearTimers();

      this.items.forEach((item, index) => {
        item.classList.remove(
          'is-active',
          'is-leaving',
          'is-left',
          'is-center',
          'is-right',
          'is-hidden'
        );
        item.setAttribute('aria-hidden', 'true');

        if (index === 0) {
          item.classList.add('is-active');
          item.setAttribute('aria-hidden', 'false');
        }
      });

      this.currentIndex = 0;
    }

    destroy() {
      this.clearTimers();

      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = null;
      }

      window.removeEventListener('resize', this.handleResize);
    }

    clearTimers() {
      if (this.holdTimer) {
        clearTimeout(this.holdTimer);
        this.holdTimer = null;
      }

      if (this.cleanupTimer) {
        clearTimeout(this.cleanupTimer);
        this.cleanupTimer = null;
      }
    }

    handleResize() {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        const nextType = this.getCurrentType();

        if (nextType !== this.type) {
          this.init();
        }
      }, 120);
    }

    /* =========================
       SLIDE MODE
       ========================= */

    initSlider() {
      this.items.forEach((item, index) => {
        item.classList.remove('is-left', 'is-center', 'is-right', 'is-hidden', 'is-leaving');
        item.classList.remove('is-active');
        item.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');

        if (index === 0) {
          item.classList.add('is-active');
        }
      });

      if (!this.reducedMotion && this.items.length > 1) {
        this.queueNextSlide();
      }
    }

    queueNextSlide() {
      this.clearTimers();

      this.holdTimer = window.setTimeout(() => {
        this.advanceSlide();
      }, this.delay);
    }

    advanceSlide() {
      const current = this.items[this.currentIndex];
      const nextIndex = (this.currentIndex + 1) % this.items.length;
      const next = this.items[nextIndex];

      next.classList.remove('is-leaving');
      next.classList.add('is-active');
      next.setAttribute('aria-hidden', 'false');

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');

      this.currentIndex = nextIndex;

      this.cleanupTimer = window.setTimeout(() => {
        current.classList.remove('is-leaving');
        this.queueNextSlide();
      }, this.transitionDuration);
    }

    /* =========================
       TICKER MODE
       3-position carousel
       ========================= */

    initTicker() {
      this.applyTickerClasses();

      if (!this.reducedMotion && this.items.length > 1) {
        this.queueNextTicker();
      }
    }

    queueNextTicker() {
      this.clearTimers();

      this.holdTimer = window.setTimeout(() => {
        this.advanceTicker();
      }, this.delay);
    }

    advanceTicker() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.applyTickerClasses();

      this.cleanupTimer = window.setTimeout(() => {
        this.queueNextTicker();
      }, this.transitionDuration);
    }

    applyTickerClasses() {
      const total = this.items.length;

      if (total === 1) {
        this.items[0].classList.add('is-center');
        this.items[0].setAttribute('aria-hidden', 'false');
        return;
      }

      const getWrappedIndex = (index) => (index + total) % total;

      const centerIndex = this.currentIndex;
      const leftIndex = getWrappedIndex(this.currentIndex - 1);
      const rightIndex = getWrappedIndex(this.currentIndex + 1);

      this.items.forEach((item, index) => {
        item.classList.remove(
          'is-active',
          'is-leaving',
          'is-left',
          'is-center',
          'is-right',
          'is-hidden'
        );

        if (index === centerIndex) {
          item.classList.add('is-center');
          item.setAttribute('aria-hidden', 'false');
        } else if (index === leftIndex) {
          item.classList.add('is-left');
          item.setAttribute('aria-hidden', 'true');
        } else if (index === rightIndex) {
          item.classList.add('is-right');
          item.setAttribute('aria-hidden', 'true');
        } else {
          item.classList.add('is-hidden');
          item.setAttribute('aria-hidden', 'true');
        }
      });
    }
  }

const initKaraokeReveal = () => {
    const karaokeElements = document.querySelectorAll('.karaoke-text');
    if (!karaokeElements.length) return;

    // Wrap each word in a span so they can light up individually
    karaokeElements.forEach(el => {
      if (!el.dataset.wrapped) {
        const words = el.innerText.trim().split(' ');
        el.innerHTML = words.map(w => `<span class="k-word">${w}</span>`).join(' ');
        el.dataset.wrapped = 'true';
      }
    });

    const updateKaraoke = () => {
      // Check if the user has hit the absolute bottom of the page
      const isAtBottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 20;

      karaokeElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        const startReveal = windowHeight * 0.85; 
        const endReveal = windowHeight * 0.60; // Ends earlier on the screen now
        
        // Calculate overall progress from 0 to 1
        let progress = 0;
        if (isAtBottom) {
          progress = 1; // Force 100% completion if we hit the footer
        } else if (rect.top > startReveal) {
          progress = 0;
        } else if (rect.top < endReveal) {
          progress = 1;
        } else {
          progress = (startReveal - rect.top) / (startReveal - endReveal);
        }
        
        const words = el.querySelectorAll('.k-word');
        const total = words.length;
        
        // Fill words sequentially based on progress
        words.forEach((word, index) => {
          const wordStart = index / total;
          const wordEnd = (index + 1) / total;
          
          let wordProgress = 0;
          if (progress >= wordEnd) {
            wordProgress = 100;
          } else if (progress <= wordStart) {
            wordProgress = 0;
          } else {
            wordProgress = ((progress - wordStart) / (wordEnd - wordStart)) * 100;
          }
          
          word.style.setProperty('--wp', `${wordProgress}%`);
        });
      });
    };

    window.addEventListener('scroll', updateKaraoke, { passive: true });
    updateKaraoke(); // Run once on load
  };
  const initRotatingStats = (scope = document) => {
    scope.querySelectorAll('[data-rotating-stats]').forEach((element) => {
      new RotatingStatsBanner(element);
    });
    initKaraokeReveal();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRotatingStats());
  } else {
    initRotatingStats();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initRotatingStats(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-rotating-stats]').forEach((element) => {
      if (element._instance) {
        element._instance.destroy();
      }
    });
  });
})();